import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const submitDispute = (payload) => {
  return apiClient(ENDPOINTS.DISPUTE.SUBMIT, {
    method: "POST",
    body: payload,
  });
};

export const getAllDisputes = (CustomerId) => {
  return apiClient(ENDPOINTS.DISPUTE.GET_BY_CUSTOMER(CustomerId), {
    method: "GET",
  });
};

export const getAllRaisedDisputes = (TeamID) => {
  return apiClient(ENDPOINTS.DISPUTE.GET_BY_ASSIGNED_USER(TeamID), {
    method: "GET",
  });
};

// Update dispute status (POST)
export const updateDisputeStatus = (payload) => {
  return apiClient(ENDPOINTS.DISPUTE.UPDATE_RESOLUTION, {
    method: "POST",
    body: payload,
  });
};

// disputeService.js
export const fetchDisputeComments = (disputeId) => {
  return apiClient(ENDPOINTS.COMMENT_LOG.GET_BY_DISPUTE(disputeId), {
    method: "GET",
  });
};

export const postDisputeComment = (payload) => {
  return apiClient(ENDPOINTS.COMMENT_LOG.POST, {
    method: "POST",
    body: payload,
  });
};

export const fetchDisputeHierarchy = () => {
  return apiClient(ENDPOINTS.USER_DISPUTE_HIERARCHY_ALL, {
    method: "GET",
  });
};

export const createDisputeHierarchy = (payload) => {
  return apiClient(ENDPOINTS.USER_DISPUTE_HIERARCHY_CREATE, {
    method: "POST",
    body: payload,
  });
};

export const updateDisputeHierarchy = (id, payload) => {
  return apiClient(ENDPOINTS.USER_DISPUTE_HIERARCHY_UPDATE, {
    method: "PUT",
    body: payload,
  });
};

export const deleteDisputeHierarchy = (custId, catId) => {
  return apiClient(
    ENDPOINTS.USER_DISPUTE_HIERARCHY_DELETE(custId, catId),
    {
      method: "DELETE",
    }
  );
};
//  restict to raised disupte if hierarchy is not set

export const hasDisputeHierarchy = (custId, catId) => {
  return apiClient(ENDPOINTS.DISPUTE.HAS_HIERARCHY(custId, catId), {
    method: "GET",
  });
};